import React, { useState } from 'react';
import './TechClientsCollaborations.css';
import govKarnatakaImg from '../../Assets/tech/techaccordian1.png';
import procurementVendorImg from '../../Assets/tech/techaccordian2.png';
import mapsErpImg from '../../Assets/tech/techaccordian3.png';
import samruddhiImg from '../../Assets/tech/techaccordian4.png';
import aQracImg from '../../Assets/tech/techaccordian5.png';
import vcnrLogo from '../../Assets/vcnr-logo-white.png';
import infratech from '../../Assets/tech/techaccordian6.png';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const ClientsCollaborations = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const projects = [
    {
      title: 'WMS Inventory Management System',
      description: `The Warehouse Management System (WMS) is a comprehensive enterprise solution widely used across India. It enables warehouses to track and manage inventory seamlessly from arrival to dispatch, while an optional logistics module extends visibility by monitoring consignments from inbound to final delivery.`,
      links: [
        { url: 'vcnrtech.com', label: 'vcnrtech.com' },
      
      ],
      image: govKarnatakaImg 
    },
    {
      title: 'Procurement & Vendor Management (Reqvise)',
      description: `Reqvise procurement platform is a cloud-based solution that streamlines and automates the entire procurement lifecycle—from requisition to payment—enabling organizations to manage purchasing activities with greater efficiency and transparency.`,
      links: [
        { url: 'reqvise.com', label: 'reqvise.com' },
       { url: 'vcnrtech.com', label: 'vcnrtech.com' },
      ],
      image: procurementVendorImg
    },
    {
      title: 'MProvise - MRP for SME Segment',
      description: `MProvise is the the most cost effective MRP solution for SME segment, Job tracking, Material management, GST Invoicing solution for small and medium enterprise.`,
      links: [
        { url: 'vcnrtech.com', label: 'vcnrtech.com' },
      ],
      image: mapsErpImg
    },
    {
      title: 'Samruddhi Aggregation Platform',
      description: `Built a scalable aggregation platform connecting farmers with retailers.

Enabled real-time pricing, inventory management, and seamless order processing across the supply chain.`,
      links: [
        { url: 'vcnrtech.com', label: 'vcnrtech.com' },
      ],
      image: samruddhiImg
    },
    {
      title: 'ViCare - Health Asessment Platform',
      description: `ViCare is a health asessement product focusing on providing the innovative healthcare solutions to improve the quality of life.`,
      links: [
        { url: 'https://hrdayin.com/', label: 'hrdayin.com' },
         { url: 'vcnrtech.com', label: 'vcnrtech.com' }
      ],
      image: aQracImg
    },

    {
      title: 'Infratraq: The Complete Construction Managment Platform',
      description: `Infratraq is a cloud-based platform that streamlines and automates the entire construction lifecycle — from project planning and cost estimation to resource and material management. It empowers construction companies to manage operations with greater efficiency, accuracy, and transparency.`,
      links: [
       
         { url: 'vcnrtech.com', label: 'vcnrtech.com' }
      ],
      image: infratech
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className='clients-collab__wrapper'>
    <div className="clients-collab__section">
      <div className="clients-collab__header">
        <h2 className="clients-collab__title">Our Clients & Collaborations</h2>
        <h3 className="clients-collab__subtitle">Built With the Best</h3>
        <p className="clients-collab__description">
Apart from serving our esteemed clients, we collaborate with forward-thinking organizations that believe
 in using innovation to create real-world impact. Our partnerships span across industries and missions, 
 but share one common goal: building smarter, scalable tools for better outcomes.
        </p>
      </div>

      <div className="clients-collab__accordion">
        {projects.map((project, index) => (
          <div key={index} className="clients-collab__item">
            <button
              className={`clients-collab__toggle ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleAccordion(index)}
            >
              {project.title}
              <span className="clients-collab__arrow">{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
            </button>
            {activeIndex === index && (
              <div className="clients-collab__details">
                <div className="clients-collab__details-inner">
                  <img
                    className="clients-collab__image"
                    src={project.image}
                    alt={project.title}
                  />
                  <div className="clients-collab__text">
                    <h4 className="clients-collab__project-title">{project.title}</h4>
                    <div className="clients-collab__highlight-bar"></div>
                    <img src={vcnrLogo} alt="VCNR Logo" className="clients-collab__brand"/>
                    <p className="clients-collab__project-description">{project.description}</p>
                    <div className="clients-collab__links">
                      {project.links.map((link, i) => (
                        <a
                          key={i}
                          href={`https://${link.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="clients-collab__link"
                        >
                          {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default ClientsCollaborations;
